var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommvault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13L14.2908 18.6069V29.3931L24 35L33.7093 29.3931V18.6069L24 13ZM32.024 28.423L23.9918 33.0598L15.9597 28.423V19.577L23.9918 14.9402L32.024 19.577V28.423Z",
    fill: "#FF4A6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.441 30.8255C23.441 30.9077 23.3506 30.957 23.2766 30.9159L17.6204 27.6521C17.5217 27.5945 17.4559 27.4876 17.4559 27.3725V21.0586C17.4559 20.9764 17.5464 20.9271 17.6204 20.9682L23.2766 24.232C23.3752 24.2896 23.441 24.3965 23.441 24.5116V30.8255ZM29.6233 20.105L24.2138 23.229C24.0822 23.303 23.9178 23.303 23.7863 23.229L18.3767 20.105C18.3027 20.0639 18.3027 19.957 18.3767 19.9159L23.7863 16.7918C23.9178 16.7178 24.0822 16.7178 24.2138 16.7918L29.6233 19.9159C29.6973 19.957 29.6973 20.0639 29.6233 20.105ZM29.6233 28.0796L24.7153 30.9159C24.6413 30.957 24.5509 30.9077 24.5509 30.8255V25.161C24.5509 25.0788 24.6413 25.0295 24.7153 25.0706L29.6233 27.9069C29.6973 27.9398 29.6973 28.0385 29.6233 28.0796Z",
    fill: "#FF4A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommvault);
export default __webpack_public_path__ + "static/media/Commvault.6716f0c1c7d5c11b26a3875b4c221bba.svg";
export { ForwardRef as ReactComponent };